module.exports = __webpack_public_path__ + "static/media/prod.94fe29d9.bin";